module.exports = {
    "dismiss": `Opusti`
};


//# sourceMappingURL=sl-SI.main.js.map
